import React from "react";
import "./timeline.css";

export default function Timeline() {
  return (
    <div id="experiences">
      <div className="timeline-title">My Experiences</div>
      <div className="timeline">
        <div className="timeline-container">
          <div className="container left">
            <div className="content">
              <div className="timeline-date">October 2022 - Now</div>
              <div className="timeline-place">Web Developer - PT. Garda Paksi Nusantara</div> <br />
              <div className="timeline-desc">
                <ul>
                  <li>Build and develop websites using full-stack JavaScript and Laravel.</li>
                  <li>Conduct web and mobile application training for personnel in the field.</li>
                  <li>Responsible for monitoring applications at 20 sites related to absence, reports, and application bugs.</li>
                </ul>
              </div>
            </div>
          </div>
          <div className="container right">
            <div className="content">
              <div className="timeline-date">July 2022 - September 2022</div>
              <div className="timeline-place">Web Developer - Freelance</div> <br />
              <div className="timeline-desc">
                <ul>
                  <li>Fixed bugs and added some new features on the sales web.</li>
                  <li>Make a website interface display according to the design from Figma.</li>
                </ul>
              </div>
            </div>
          </div>
          <div className="container left">
            <div className="content">
              <div className="timeline-date">January 2022 - June 2022</div>
              <div className="timeline-place">Software Developer - PT. Infimech Harmoni Teknologi</div> <br />
              <div className="timeline-desc">
                <ul>
                  <li>Add some features and change the appearance of front end website to be more elegant and interactive</li>
                  <li>Make CFD (Computational Fluid Dynamics) simulation using OpenFoam</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
